<template>
  <div style="color: #4a4a4a; font-size: 14px">
    <div class="steps-title">注册流程说明</div>
    <div class="steps-list">
      <p>
        1.下载<span class="adownload" @click="templateDownload"
          >授权委托书模板</span
        >。
      </p>
      <p>2.填写授权委托书并加盖公司公章。</p>
      <p>3.在开店申请时，上传加盖公司公章的授权委托书电子文件（PDF格式）。</p>
      <p>
        4.扫码支付店铺服务费。店铺服务费标准为:
        <span style="color: #ff142f">￥{{ cost }}元/年。</span>
      </p>
      <div class="zhu">注：店铺服务包含系统和业务培训、平台店铺管理服务、商品管理服务、订单处理服务、物流实时追踪、客户服务、数据分析、用户信息安全保障等。</div>
    </div>
    <div style="height: 164px"></div>
  </div>
</template>

<script>
import {
  templateDownloadwlxt,
  templateDownloadzlxt,
  templateDownloadjcxt,
} from "@/api/lessor-open-shop.js";

export default {
  data() {
    return {
      cost: "3000.00",
    };
  },
  methods: {
    templateDownload() {
      // 8 云租 9 物流 10 二级集采
      const orderPurchaseType = this.$route.query.orderPurchaseType || 8;
      if (orderPurchaseType == "8") {
        templateDownloadzlxt().then((res) => {
          this.handelDownload(res);
        });
      } else if (orderPurchaseType == "9") {
        templateDownloadwlxt().then((res) => {
          this.handelDownload(res);
        });
      } else if (orderPurchaseType == "10") {
        templateDownloadjcxt().then((res) => {
          this.handelDownload(res);
        });
      }
    },
    handelDownload(res) {
      let blob = new Blob([res.data], {
        type: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob);
      } else {
        let elink = document.createElement("a");
        if (
          res.headers["content-disposition"] &&
          res.headers["content-disposition"].split(";").length > 1 &&
          res.headers["content-disposition"].split(";")[1].split("filename*=")
            .length > 1
        ) {
          let filename = res.headers["content-disposition"]
            .split(";")[1]
            .split("filename*=")[1];
          filename = window.decodeURIComponent(filename);
          filename = filename.split("utf-8''")[1];
          console.log(filename);
          elink.download = filename;
        }
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    },
  },
};
</script>

<style lang="scss" scoped >
.steps-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
}
.zhu{
  font-size: 12px;
  color: #999;

}
.steps-list {
  font-size: 14px;
  line-height: 32px;
  font-weight: 400;
  .adownload {
    cursor: pointer;
    color: #0089ef;
    text-decoration: underline;
  }
}
</style>